export default "__VITE_ASSET__DDPAr6pr__"